import { render, staticRenderFns } from "./shapeElement.vue?vue&type=template&id=15d32f7e&scoped=true&"
import script from "./shapeElement.vue?vue&type=script&lang=js&"
export * from "./shapeElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d32f7e",
  null
  
)

export default component.exports